/**
 * Enums describing the various policies for deciding layers.
 * @module
 */

var keyMirror = require('keymirror');

/**
 * The list of supported layer policies.
 * @enum
 */
exports.LayerPolicies = keyMirror({
  equal_priority: null,
  multivariate: null,
  ordered: null,
  random: null,
  single_experiment: null,
});
